import React from "react"
import { Grid, Stack } from "@mui/material"
import { FormikTextField } from "../../../../../../../shared/components/forms/Formik"
import { BillReceiversFormValuesType } from "../../billReceiversTypes"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

export function DetailsAddressFormSection() {
    return (
        <Stack spacing="1rem">
            <LocalizedStrict id="bill-receivers-form-label-address-1" attrs={{ label: true, placeholder: true }}>
                <FormikTextField<BillReceiversFormValuesType>
                    name="addressLine1"
                    label="Address line 1 (*)"
                    placeholder="Street and street number"
                    fullWidth
                />
            </LocalizedStrict>
            <LocalizedStrict id="bill-receivers-form-label-address-2" attrs={{ label: true, placeholder: true }}>
                <FormikTextField<BillReceiversFormValuesType>
                    name="addressLine2"
                    label="Address line 2"
                    placeholder="Floor, apartment no., etc."
                    fullWidth
                />
            </LocalizedStrict>
            <Grid container flexWrap="nowrap" gap="1.25rem">
                <Grid item xs={4}>
                    <LocalizedStrict id="bill-receivers-form-label-postal-code" attrs={{ label: true }}>
                        <FormikTextField<BillReceiversFormValuesType>
                            name="postalCode"
                            label="Postal code (*)"
                            fullWidth
                        />
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={8}>
                    <LocalizedStrict id="bill-receivers-form-label-city" attrs={{ label: true }}>
                        <FormikTextField<BillReceiversFormValuesType> name="city" label="City (*)" fullWidth />
                    </LocalizedStrict>
                </Grid>
            </Grid>
        </Stack>
    )
}
